import React, { useState } from 'react';
import { useHistory } from "react-router-dom";
import { useForm } from 'react-hook-form';
import { SHA256 } from 'utils/SHA256';
import Popup from 'popup/Popup';
import { customAxiosPostFunction } from 'utils/axiosFunction';
import { PwdEditablePopupContainer } from './PwdEditablePopup.css.js';

const PwdEditablePopup = ({ user, dataReloadFunc, children }) => {
  const history = useHistory();
  const { register, handleSubmit, errors, clearErrors } = useForm();
  const [ popupOpen, setPopupOpen ] = useState(null);

  const confirmModule = async (data) => {
    if (data.pwd !== data.confirmPwd) {
      alert("비밀번호를 다시 확인해주세요");
      return false;
    }

    if (!window.confirm('기존 비밀번호가 삭제되고 새 비밀번호로 대체됩니다.\n계속 진행하시겠습니까?')) {
      return false;
    }

    customAxiosPostFunction(history, '/api/user/updatePwd', { userIdx: user.userIdx, pwd: SHA256(data.pwd) })
      .then(response => {
        if (response === 1) {
          alert(`수정완료`);
          setPopupOpen(false);
          dataReloadFunc();
        }
        else {
          alert(`수정실패`);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  return(
    <Popup
      trigger={
        children
      }
      modal
      open={popupOpen}
      onOpen={() => { setPopupOpen(true); }}
      onClose={() => { clearErrors(); }}
    >
      <PwdEditablePopupContainer>
        <form onSubmit={ handleSubmit(confirmModule) }>
          <div>
            <div>
              <p>새 비밀번호</p>
              <input type="password"
                    name="pwd"
                    ref={register({ required: true, minLength: 8, maxLength: 15, pattern: /^.*(?=^.{8,15}$)(?=.*\d)(?=.*[a-zA-Z])(?=.*[!@#$%^&+=]).*$/ })} /> 
            </div>
            <div className="error-box">{errors.pwd && "올바른 비밀번호를 입력해주세요"}</div>
          </div>
          <div>
            <div>
              <p>새 비밀번호 확인</p>
              <input type="password"
                    name="confirmPwd"
                    ref={register({ required: true })} /> 
            </div>
            <div className="error-box">{errors.confirmPwd && "확인용 비밀번호를 입력해주세요"}</div>
          </div>
          <button type="submit">수정</button>
        </form>
      </PwdEditablePopupContainer>
      
    </Popup>
  );
}

export default PwdEditablePopup;